export default __webpack_public_path__ + "static/media/dog.d6ba3fed.ogg";